import { FooterContainerDiv, FooterStyleMainDiv } from "../../../styles/reusable/footer/footerstyles";
import IndexSignUpCtaComponent from "../../indexcomponents/indexsingupctacomponent";
import Logo from "./assets/bugzi logo 2.png";
import bg_gradient from "./assets/background (1).png"
const Footer = () => {
  return (

    <FooterContainerDiv>
      <div className=" gradient-container">

        </div>
      <IndexSignUpCtaComponent />
      <div style={{minHeight:"400px"}}>
        
        <FooterStyleMainDiv>

          <div>
            <div className="footer-container">
              <div>
                <div>
                  <div className="footer-top-container">
                    <div>
                      <div className="footer-left-container">
                        <a className="footer-logo-holder" href="/">
                          <div>
                            <div className="footer-logo-container">
                              <img src={Logo} alt="" />
                            </div>
                          </div>
                          <div>
                            <div className="footer-text-wrapper">
                              <h4> Bugzi AI</h4>{" "}
                            </div>
                          </div>
                        </a>
                        <div>
                          <div className="footer-text-wrapper">
                            <p>Your AI, Your IDE — Power Where You Build</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="footer-right-container">
                      {Data.map((linksObject, linksIndex) => (
                        <div
                          className="footer-links-container"
                          key={"Links-holder" + linksIndex}
                        >
                          <div>
                            <div className="footer-link-header-container ">
                              {" "}
                              <p> {linksObject.header} </p>
                            </div>
                          </div>
                          {linksObject.links.map((item, index) => (
                            <div>
                              <div>
                                <a
                                  href={item.url}
                                  className="footer-link-container"
                                >
                                  {item.name}
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </FooterStyleMainDiv>
      </div>



    </FooterContainerDiv>


  );
};

const Data = [
  {
    header: "Company",
    links: [
      { name: "Homepage", url: "/" },
      { name: "pricing", url: "/pricing" },
      { name: "Integration", url: "/integration" },
      { name: "Enterprise", url: "/enterprise" },
      { name: "Contact", url: "/contact" },
      { name: "About  Us", url: "/about-us" },
    ],
  },

  {
    header: "Resources",
    links: [
      { name: "Documentation", url: "/documentation" },
      { name: "ChangeLog", url: "/changeLog" },
      { name: "Terms & condition", url: "/terms-condition" },
      { name: "Privacy", url: "/privacy" },
    ],
  },
  {
    header: "Others",
    links: [
      { name: "Career", url: "" },
      { name: "Team", url: "" },
      { name: "Reports ", url: "" },
      { name: "Faq", url: "" },
      { name: "Blog", url: "/blog" },
    ],
  },
];

export default Footer;
